/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState } from "react";
import {
  Box, Grid, Paper, Select, Tabs, Tab,
  Typography
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import TerminalViewDetail from "../../terminal/terminalView/TerminalViewDetail";
import MerchantViewDetail from "../../merchant/merchantView/MerchantViewDetail";
import PosViewDetail from "../../pos/posView/PosViewDetail";
import ProgressIndicator from "../../../common/progressIndicator/ProgressIndicator";
import pageStyles from "../../pageStyles";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

export type Option = { label: string; value: string | number | boolean };

interface MappingDataProps {
  onboardData?: any[];
  isLoading?: boolean;
}
const MappingData = (props: MappingDataProps) => {
  const { onboardData, isLoading } = props;
  const classes = pageStyles();

  const [activeRow, setActiveRow] = useState(onboardData.length ? 0 : "");
  const [type, selectViewType] = useState(0);
  let terminalData = null;
  if (onboardData[activeRow]) {
    terminalData = onboardData[activeRow].Terminal;
  }

  const renderPreview = () => {
    switch (type) {
      case 0: {
        return (
          <TerminalViewDetail terminalData={terminalData} merchantData={onboardData[activeRow].Merchant} />
        )
      }
      case 1: {
        return (
          <MerchantViewDetail merchantData={onboardData[activeRow].Merchant} />
        )
      }
      case 2: {
        return (
          <PosViewDetail posData={onboardData[activeRow].POS} />
        )
      }
    }
  }

  return (
    <Grid spacing={2} xs={12}>
      {isLoading ? (
        <Box width="100%" textAlign="center">
          <ProgressIndicator />
          <Typography>
            Mapping data...
            <br />
            Please wait a moment
          </Typography>
        </Box>
        ) : (
        <>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            flexDirection="row"
            width="100%"
            padding={2}
          >
            <h2>
              <Typography>Viewing SerNo: <strong>{terminalData?.attributes?.SerNo}</strong></Typography>
            </h2>
            {/*<label>*/}
            {/*  <span>Select Section to preview</span>*/}
            {/*  <Select*/}
            {/*    style={{ marginLeft: "10px" }}*/}
            {/*    onChange={(e) => {*/}
            {/*      const { value } = e.target;*/}
            {/*      selectViewType(value)*/}
            {/*    }}*/}
            {/*    value={type}*/}
            {/*  >*/}
            {/*    <MenuItem key="type-Terminal" value="Terminal">Terminal</MenuItem>*/}
            {/*    <MenuItem key="type-Merchant" value="Merchant">Merchant</MenuItem>*/}
            {/*    <MenuItem key="type-POS" value="POS">POS</MenuItem>*/}
            {/*  </Select>*/}
            {/*</label>*/}
            <Tabs
              value={type}
              onChange={(event: React.SyntheticEvent, newValue: number) => {
                selectViewType(newValue)
              }}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
            >
              <Tab label="Terminal" />
              <Tab label="Merchant" />
              <Tab label="POS" />
            </Tabs>
            <label>
              <span>Select Row to preview</span>
              <Select
                style={{ marginLeft: "10px" }}
                onChange={(e) => {
                  const { value } = e.target;
                  setActiveRow(value)
                }}
                value={activeRow}
              >
                <MenuItem value={""}>None</MenuItem>
                {onboardData.map((value, row) => (
                  <MenuItem key={'active-' + row} value={row}>{Number(row + 1)}</MenuItem>
                ))}
              </Select>
            </label>

          </Box>
          <Grid item xs={12}>
            <Paper style={{
              position: "relative",
              width: "100%",
              height: "calc(100vh - 420px)",
              overflowY: "auto",
            }} className={classes.paper as string} >
              {terminalData && terminalData.id ? renderPreview() : (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  flexDirection="column"
                  width="100%"
                  padding={4}
                >
                  <ErrorOutlineOutlinedIcon
                    fontSize="large"
                    style={{ color: "#ccc", marginBottom: 10 }}
                  />
                  <Typography align="center">
                    Cannot Find this SerNo: {terminalData?.attributes?.SerNo}
                  </Typography>
                </Box>
              )}
            </Paper>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default MappingData;
